!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("sessionStorageLib", [], t) : "object" == typeof exports ? exports.sessionStorageLib = t() : e.sessionStorageLib = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
        d: function d(t, r) {
          for (var o in r) e.o(r, o) && !e.o(t, o) && Object.defineProperty(t, o, {
            enumerable: !0,
            get: r[o]
          });
        },
        o: function o(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        },
        r: function r(e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }
      },
      t = {};
    e.r(t), e.d(t, {
      SS_LIST: function SS_LIST() {
        return b;
      },
      addKeyConfigMapping: function addKeyConfigMapping() {
        return m;
      },
      getItemBySession: function getItemBySession() {
        return C;
      },
      itemType: function itemType() {
        return a;
      },
      removeItemBySession: function removeItemBySession() {
        return F;
      },
      setItemBySession: function setItemBySession() {
        return S;
      }
    });
    var r = "undefined" != typeof window;
    var o = "awefewfuihewfhewfuhiebc",
      i = "limitedConsent",
      n = "enct-",
      a = {
        ES: "essential",
        N_ES: "nonEssential"
      };
    function s(e) {
      return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, s(e);
    }
    function l(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" !== s(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var o = r.call(e, "string");
            if ("object" !== s(o)) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(e);
        return "symbol" === s(t) ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var u = "GI",
      c = "IGO",
      f = "AFFCGOBIZMMTAIX",
      d = (l(l(l({}, u, {
        colors: {
          base: {
            primary: "#016eff"
          },
          button: {
            primary: {
              bg: "linear-gradient(93deg, #FF6D38, #FF6D38)",
              text: "#FFFFFF"
            }
          }
        },
        style: {
          button: {
            borderRadius: "8px"
          }
        },
        font: {
          urls: ["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],
          family: "'Quicksand', sans-serif",
          familyHeading: "'Quicksand', sans-serif"
        }
      }), c, {
        colors: {
          base: {
            primary: "#00228E"
          },
          button: {
            primary: {
              bg: "linear-gradient(93deg, #00228E, #00228E)",
              text: "#FFFFFF"
            }
          }
        },
        style: {
          button: {
            borderRadius: "8px"
          }
        },
        font: {
          urls: ["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap", "https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],
          family: "'Lato'",
          familyHeading: "'ITC Bauhaus'"
        }
      }), f, {
        colors: {
          base: {
            primary: "#FF6423"
          },
          button: {
            primary: {
              bg: "linear-gradient(93deg, #FF6D38, #FF6D38)",
              text: "#FFFFFF"
            }
          }
        },
        style: {
          button: {
            borderRadius: "8px"
          }
        },
        font: {
          urls: ["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap", "https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],
          family: "'Lato'",
          familyHeading: "'ITC Bauhaus'"
        }
      }), l(l({}, u, {
        ACCOUNTS_TERMS_CONDITION: "https://giholidays.makemytrip.com/legal/gi/user_agreement.html",
        ACCOUNTS_PRIVACY_URL: "https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",
        TERMS_OF_SERVICE: "https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"
      }), c, {
        ACCOUNTS_TERMS_CONDITION: "https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",
        ACCOUNTS_PRIVACY_URL: "https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",
        TERMS_OF_SERVICE: "https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"
      }), function (e) {
        var t,
          o = e || "";
        r && (o = (null === (t = window) || void 0 === t || null === (t = t.location) || void 0 === t ? void 0 : t.hostname) || "");
        var i = "";
        return o && (-1 !== o.indexOf("giholidays") ? i = u : -1 !== o.indexOf("6eholidays") ? i = c : -1 !== o.indexOf("hdfcsmartbuyholidays") ? i = "HDFC_SB" : -1 !== o.indexOf("airindiaexpressholidays") ? i = f : -1 !== o.indexOf("flightsexpert.goibibo") ? i = "AFFCGOBIZGIFLTEXP" : -1 !== o.indexOf("flightsexpert.makemytrip") ? i = "AFFCGOBIZMMTFLTEXP" : -1 !== o.indexOf("forexexpert.makemytrip") ? i = "AFFTMFXMMTFOREXEXP" : -1 !== o.indexOf("forexexpert.goibibo") && (i = "AFFTMFXGIFOREXEXP")), i;
      }),
      y = {},
      m = function m(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        y[e] = t;
      },
      p = function p(e, t, o, i) {
        var n,
          s,
          l = o,
          u = i,
          c = (null == y ? void 0 : y[e]) || {};
        return r && (l = void 0 === o ? (null === (n = c[t]) || void 0 === n ? void 0 : n.type) || a.N_ES : o, u = void 0 === i ? (null === (s = c[t]) || void 0 === s ? void 0 : s.isPiiData) || !1 : i), {
          essential: l = l === a.ES,
          piiData: u
        };
      },
      g = function g(e) {
        var t,
          r,
          o = function (e) {
            return new RegExp("(?:^|;\\s*)".concat(e, "\\s*=\\s*([^;]*)"));
          }((t = e, (r = d(undefined).toLowerCase()) ? "".concat(t, "-").concat(r) : t)),
          i = o.exec(document.cookie);
        return null !== i ? decodeURIComponent(i[1]) : null;
      },
      h = function h() {
        var e, t, r, o;
        return "1" !== g("isGdprRegion") || (e = g("myBusinessSubscription"), r = null == (t = g("mmt-auth")) ? void 0 : t.charAt(t.length - 1), !!(e && "b2b" === e || "C" === r) || (!(o = g("GDPR_C")) || "IS" !== o && "11" !== o ? "fullConsent" : i) !== i);
      },
      b = "sessionList",
      v = function v(e) {
        return new TypeError("Valid key & value is required for sessionStorage ".concat(e));
      },
      S = function S(e, t, i, a) {
        try {
          if (!r || !sessionStorage) return !1;
          if (!e || void 0 === t) throw v("get");
          var s,
            l = (i || {}).isPiiData,
            u = (i || {}).shouldStringifyJson,
            c = p(b, e, a, l);
          if (s = c.essential, l = c.piiData, !s && !h()) return !1;
          var f = u ? function (e) {
            try {
              return JSON.stringify(e);
            } catch (e) {
              return null;
            }
          }(t) : t;
          if (f && l) {
            var d = function (e, t) {
              try {
                var r = "",
                  o = 0;
                if (!t) throw new Error("Key is empty");
                for (var i = 0; i < e.length; i += 1) {
                  var n = e.charCodeAt(i) ^ t.charCodeAt(o);
                  r += String.fromCharCode(n), o = (o + 1) % t.length;
                }
                return r;
              } catch (e) {
                return console.error("An error occurred during encryption:", e), null;
              }
            }(f, o);
            if (!d) return !1;
            f = "".concat(n).concat(d);
          }
          return sessionStorage.setItem(e, f), !0;
        } catch (e) {
          return !1;
        }
      },
      F = function F(e) {
        try {
          if (!r || !sessionStorage) return !1;
          if (!e) throw v("get");
          return sessionStorage.removeItem(e), !0;
        } catch (e) {
          return !1;
        }
      },
      C = function C(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = arguments.length > 2 ? arguments[2] : void 0;
        try {
          var a;
          if (!r || !sessionStorage) return null;
          if (!e) throw v("get");
          var s,
            l = (t || {}).isPiiData,
            u = (t || {}).shouldParseJson,
            c = p(b, e, i, l);
          if (s = c.essential, l = c.piiData, !s && !h()) return null;
          var f = sessionStorage.getItem(e);
          if (l && null !== (a = f) && void 0 !== a && a.includes(n)) {
            var d = new RegExp("^".concat(n));
            f = function (e, t) {
              try {
                var r = "",
                  o = 0;
                if (!t) throw new Error("Key is empty");
                for (var i = 0; i < e.length; i += 1) {
                  var n = e.charCodeAt(i) ^ t.charCodeAt(o);
                  r += String.fromCharCode(n), o = (o + 1) % t.length;
                }
                return r;
              } catch (e) {
                return console.error("An error occurred during the decryption process:", e), null;
              }
            }(f = f.replace(d, ""), o);
          }
          return u && (f = function (e) {
            try {
              return JSON.parse(e);
            } catch (e) {
              return null;
            }
          }(f)), f;
        } catch (e) {
          return !1;
        }
      };
    return t;
  }();
});